// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".catalogProductPage_CEapL{background-color:#fef5f0;position:relative;padding-top:4rem;padding-bottom:4.1rem}.catalogProductPage_CEapL p{text-align:center;font-size:1.6rem;font-weight:700}@media screen and (min-width:1025px){.catalogProductPage_CEapL p{font-size:2.8rem}}.catalogProductPage_CEapL:after,.catalogProductPage_CEapL:before{content:\"\";position:absolute;height:100%;width:calc(50vw - 50%);top:0;background-color:#fef5f0}.catalogProductPage_CEapL:before{right:100%}.catalogProductPage_CEapL:after{left:100%}", ""]);
// Exports
exports.locals = {
	"catalogProductPage": "catalogProductPage_CEapL"
};
module.exports = exports;
